import React, { useState } from 'react';
import { Lock, User } from 'lucide-react';

const AdminLogin = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Simulate API call delay
    setTimeout(() => {
      // Simple authentication (in production, this would be handled by a backend)
      if (formData.username === 'admin' && formData.password === 'vibrate2025') {
        onLogin();
      } else {
        setError('Invalid username or password');
      }
      setIsLoading(false);
    }, 1000);
  };

  const containerStyle = {
    minHeight: '100vh',
    paddingTop: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0a0a0f',
    color: 'white'
  };

  const cardStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '20px',
    padding: '2rem',
    maxWidth: '400px',
    width: '100%',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)'
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '2rem'
  };

  const iconStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '60px',
    height: '60px',
    background: 'linear-gradient(45deg, #ff0080, #7928ca)',
    borderRadius: '50%',
    marginBottom: '1rem',
    color: 'white'
  };

  const titleStyle = {
    fontSize: '1.8rem',
    fontWeight: '700',
    marginBottom: '0.5rem'
  };

  const subtitleStyle = {
    color: '#9ca3af',
    fontSize: '1rem'
  };

  const formGroupStyle = {
    marginBottom: '1.5rem'
  };

  const labelStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '0.5rem',
    fontWeight: '600'
  };

  const inputStyle = {
    width: '100%',
    padding: '1rem',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '12px',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    color: 'white',
    fontSize: '1rem',
    boxSizing: 'border-box'
  };

  const buttonStyle = {
    width: '100%',
    background: 'linear-gradient(45deg, #ff0080, #7928ca)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    padding: '1rem',
    fontSize: '1.1rem',
    fontWeight: '700',
    cursor: isLoading ? 'not-allowed' : 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '50px'
  };

  const errorStyle = {
    backgroundColor: 'rgba(239, 68, 68, 0.1)',
    border: '1px solid rgba(239, 68, 68, 0.3)',
    borderRadius: '8px',
    padding: '1rem',
    marginBottom: '1.5rem',
    color: '#fca5a5',
    textAlign: 'center'
  };

  const demoStyle = {
    marginTop: '2rem',
    padding: '1rem',
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    borderRadius: '10px',
    textAlign: 'center'
  };

  const demoTitleStyle = {
    color: '#ff0080',
    marginBottom: '0.5rem',
    fontWeight: '600'
  };

  const demoTextStyle = {
    color: '#d1d5db',
    fontSize: '0.9rem',
    margin: '0.25rem 0'
  };

  const strongStyle = {
    color: 'white',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    padding: '0.25rem 0.5rem',
    borderRadius: '4px',
    fontFamily: 'monospace'
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={headerStyle}>
          <div style={iconStyle}>
            <Lock size={24} />
          </div>
          <h1 style={titleStyle}>Admin Login</h1>
          <p style={subtitleStyle}>Sign in to manage events and content</p>
        </div>

        <form onSubmit={handleSubmit}>
          {error && (
            <div style={errorStyle}>
              {error}
            </div>
          )}

          <div style={formGroupStyle}>
            <label htmlFor="username" style={labelStyle}>
              <User size={18} color="#ff0080" />
              Username
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              style={inputStyle}
              placeholder="Enter your username"
              required
            />
          </div>

          <div style={formGroupStyle}>
            <label htmlFor="password" style={labelStyle}>
              <Lock size={18} color="#ff0080" />
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              style={inputStyle}
              placeholder="Enter your password"
              required
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            style={buttonStyle}
          >
            {isLoading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
